import { render } from "./BetslipToggleButton.vue?vue&type=template&id=426064dc"
import script from "./BetslipToggleButton.vue?vue&type=script&lang=js"
export * from "./BetslipToggleButton.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__